import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { NavaidModel } from 'src/app/models/navaid';
import { ConfigurationTerrain } from 'src/app/models/terrains';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CoordinatePoint } from 'src/app/models/coordinate-point';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class DynamicTable implements OnInit {

  @Input() entity : String;
  @Input() type : String;
  @Input() selectAllActive : Boolean;
  @Input() displayedColumns : String[];
  private _data : Feature[];

  @Input() set data(value : any[]){
    this._data = value;
    this.transformFeatureInDataSource(value);
  }
  get data(){
    return this._data;
  }

  private _dataTerrains : ConfigurationTerrain[];
  @Input() set dataTerrains(value : any[]){
    this._dataTerrains = value;
    this.transformTerrainsInDataSource(value);
  }
  get dataTerrains(){
    return this._dataTerrains;
  }
  public onClose: Subject<any[]>;
  @Input() public dataSource;
  public wasCanceled : Subject<boolean>;
  constructor(private bsModalRef : BsModalRef,
    private configurationService: ConfigurationService
    ) {
  }


  ngOnInit(): void {
    this.onClose = new Subject();
    this.wasCanceled = new Subject();
  }

  onLineClick(feature : any){
    if (this.type == "Terrain Select"){
      this.terrainSelection(feature);
      return;
    }
    if(this.type == "Edit" || this.type == "Horizon Tool Select"){
      this.dataSource.filteredData.forEach(el => {
        el.isSelected = false;
      })
      feature.isSelected = true;
    }
  }

  terrainSelection(feature : any){
    this.dataSource.filteredData.forEach(el => {
      if (el.TerrainName == feature.TerrainName && el.TerrainType == feature.TerrainType){
        el.isSelected = false;
      }
    })
    feature.isSelected = true;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.cancel(false); // escape key already hides the modal
  }


  cancel(hideModal: boolean = true) : void {
    this.wasCanceled.next(true);
    if (this.type == "Terrain Select"){
      let features : any = this.dataSource.filteredData.filter(el => el.isDefault);
      this.onClose.next(features);
    }
    hideModal? this.bsModalRef.hide(): false;
  }

  ok(): void {
    this.wasCanceled.next(false);
    if (this.entity == 'Coordenate Points') {
      const selectedFeatures = this.dataSource.filteredData.filter(el => el.isSelected);
      this.onClose.next(selectedFeatures);
    } else {
      let allFeatures : Feature[] = this.data;
      const selectedFeatures = this.dataSource.filteredData.filter(el => el.isSelected);
      let toDeleteFeatures : Feature[] = [];

      if (allFeatures){
        allFeatures.forEach( (elm, index) => {
          if(selectedFeatures.find( feat => feat.id == elm.get("id")) != undefined){
            toDeleteFeatures.push(elm);
          }
        });
      }

      if(this.type == "Delete"){
        this.onClose.next(toDeleteFeatures);
      }else {
        this.onClose.next(selectedFeatures);
      }

    }
    
    this.bsModalRef.hide();
  }

  selectAll() : void {
    this.dataSource.filteredData.forEach(el => {
      el.isSelected = true;
    })
  }

  deselectAll() : void {
    this.dataSource.filteredData.forEach(el => {
      el.isSelected = false;
    })
  }
  static transformCoordinatePointsInDataSource(coordinatePoints: CoordinatePoint[]){
    let transformedData : any = [];
    coordinatePoints.forEach(coordinatePoint=>{
      let newObj: any = new Object();
      newObj.id = coordinatePoint.id;
      newObj.Id = coordinatePoint.coordpointid;
      newObj.Name = coordinatePoint.name;
      newObj.Type = coordinatePoint.type;
      newObj.Published = !coordinatePoint.userdefined;
      newObj.Latitude = coordinatePoint.latitude;
      newObj.Longitude = coordinatePoint.longitude;
      newObj.isSelected = false;
      transformedData.push(newObj);
    });
    return new MatTableDataSource(transformedData);
  }
  transformFeatureInDataSource(data : Feature[]){
    let transformedData : any = [];
    data.forEach(element => {
      let newObj : any = new Object;
      newObj.id = element.getProperties().id;
      newObj.Name = element.getProperties().name;
      newObj.ICAOCode = element.getProperties().icaocc;
      newObj.Published = !element.getProperties().userdefined;
      newObj.Latitude = element.getProperties().latitude;
      newObj.Longitude = element.getProperties().longitude;
      newObj.isSelected = false;
      if(this.entity == "Navaids"){
        newObj.Id = element.getProperties().navaidid;
        newObj.Type = element.getProperties().navaidtype;
        newObj.MinScreeningAngle = element.getProperties().actualScreeningAngle;
      } else if(this.entity == "Coordenate Points"){
        newObj.Id = element.getProperties().coordpointid;
        newObj.Type = element.getProperties().type;
      } else if(this.entity == "Procedures"){
        newObj.Id = element.getProperties().procedureid;
        newObj.Type = element.getProperties().proceduretype;
        newObj.MapStatus = element.getProperties().mapstatus;
      } else if (this.entity === "Air Space Boundary") {
        newObj.Id = element.getProperties().airsoaceboundaryid;
        //newObj.Type = element.getProperties().proceduretype;
        newObj.MapStatus = element.getProperties().mapstatus;
      } else if (this.entity === "Trajectory") {
        newObj.TrajectoryId = element.getProperties().uniqueid;
        newObj.MapStatus = element.getProperties().mapstatus;
        newObj.ProcedureName = element.getProperties().procedureName;
        newObj.ProcedureId = element.getProperties().procedureId;
        newObj.TrajectoryName = element.getProperties().name;
        newObj.TotalPoints = element.getProperties().totalPoints;
      }
      else if(this.entity == "Flight Inspection" || this.entity == "Processing Tool"){
        newObj.id = element.getProperties().id;
        newObj.name = element.getProperties().name;
      }

      transformedData.push(newObj);
    })
    this.dataSource= new MatTableDataSource(transformedData);
  }

  // select terrains on project import
  async transformTerrainsInDataSource(data : ConfigurationTerrain[]){
    if (!this.configurationService.terrainTypes || this.configurationService.terrainTypes.length == 0){
      await this.configurationService.fetchTerrainTypesPromiseRequest();
    }
    let transformedData : any = [];
    data.forEach(element => {
      let newObj : any = new Object;
      newObj.id = element.id;
      newObj.projectId = element.projectId;
      newObj.path = element.path;
      newObj.active = element.active;
      newObj.position = element.position;
      newObj.isSelected = false;
      newObj.TerrainName = element.name;
      newObj.terrainTypeId = element.terrainTypeId;
      newObj.TerrainType = this.configurationService.terrainTypes[element.terrainTypeId - 1].type;
      newObj.ProjectName = element.projectName;
      if (element.name == ConfigurationTerrain.DEFAULT_TERRAIN_NAME || element.name == ConfigurationTerrain.DEFAULT_GTOPO30){
        newObj.isDefault = true;
        newObj.isSelected = true;
      } else {
        newObj.isDefault = false;
      }

      transformedData.push(newObj);
    })
    this.dataSource= new MatTableDataSource(transformedData);
  }
}
